module.exports = __webpack_public_path__ + "static/media/GUIDE_0008_01.10ff9376.jpg";